interface ComingSoonPageProps {
	title: string;
	subtitle: string;
	arrivesIn: string;
	detail: string[];
}

export function ComingSoonPage({ title, subtitle, arrivesIn, detail }: ComingSoonPageProps) {
	return (
		<div style={styles.root}>
			<div style={styles.badge}>Coming Soon · {arrivesIn}</div>
			<h1 style={styles.title}>{title}</h1>
			<p style={styles.subtitle}>{subtitle}</p>
			<ul style={styles.detail}>
				{detail.map((line, i) => (
					<li key={i}>{line}</li>
				))}
			</ul>
		</div>
	);
}

const styles: Record<string, React.CSSProperties> = {
	root: { maxWidth: 720, display: "flex", flexDirection: "column", gap: 16 },
	badge: {
		alignSelf: "flex-start",
		background: "rgba(184,92,0,0.1)",
		color: "var(--warn)",
		fontSize: 11,
		fontWeight: 600,
		textTransform: "uppercase",
		letterSpacing: 0.5,
		padding: "4px 10px",
		borderRadius: 999,
	},
	title: { margin: 0, fontSize: 28, fontWeight: 600 },
	subtitle: { margin: 0, color: "var(--muted)", fontSize: 15 },
	detail: { color: "var(--muted)", paddingLeft: 20, margin: 0 },
};
